export const headerMenu = () => {
  const elements = {
    mobileMenuBtn: document.querySelector(".header__menu-toggle"),
    header: document.querySelector(".header"),
    body: document.body,
    nav: document.querySelector(".header__menu"),
    menuItemsWithSub: document.querySelectorAll(".header__menu-item.has-sub-menu"),
    submenus: document.querySelectorAll(".header__menu-sub-menu"),
    searchForm: document.querySelector(".header__search-form-wrapper"),
    searchIcon: document.querySelector(".search-icon"),
    closeSearch: document.querySelector(".header__search-form-wrapper .close-icon"),
    searchInput: document.querySelector(".header__search-form-wrapper input[type='search'], .header__search-form-wrapper input[type='text']"),
  };

  if (!elements.mobileMenuBtn) return;

  const closeMobileMenu = () => {
    elements.mobileMenuBtn.classList.remove("menu-open");
    elements.header.classList.remove("mobile-menu-active");
    elements.body.classList.remove("mobile-menu-active");
    if (elements.nav) elements.nav.classList.remove("active");
    elements.submenus.forEach((sub) => sub.classList.remove("submenu-open"));
  };

  const closeSearchForm = () => {
    if (elements.searchForm) elements.searchForm.classList.remove("active");
  };

  elements.body.addEventListener("click", (e) => {
    if (elements.nav) {
      const isMenuActive = elements.nav.classList.contains("active");
      const isClickInsideNav = elements.nav.contains(e.target);
      const isClickOnToggle = elements.mobileMenuBtn.contains(e.target);
      if (isMenuActive && !isClickInsideNav && !isClickOnToggle) {
        closeMobileMenu();
      }
    }

    if (
      elements.searchForm?.classList.contains("active") &&
      !elements.searchForm.contains(e.target) &&
      !elements.searchIcon?.contains(e.target)
    ) {
      closeSearchForm();
    }
  });

  elements.mobileMenuBtn.addEventListener("click", () => {
    if (!elements.nav) return;
    const isMenuActive = elements.nav.classList.contains("active");
    if (isMenuActive) {
      closeMobileMenu();
    } else {
      elements.mobileMenuBtn.classList.add("menu-open");
      elements.body.classList.add("mobile-menu-active");
      elements.header.classList.add("mobile-menu-active");
      elements.nav.classList.add("active");
    }
  });

  elements.menuItemsWithSub.forEach((item) => {
    const link = item.querySelector(".header__menu-link");
    const submenu = item.querySelector(".header__menu-sub-menu");
    if (!link || !submenu) return;

    link.addEventListener("click", (e) => {
      if (window.innerWidth > 1024) return;

      const arrow = link.querySelector(".header__menu-link-arrow");
      if (!arrow || !arrow.contains(e.target)) return;

      e.preventDefault();
      e.stopPropagation();

      elements.menuItemsWithSub.forEach((other) => {
        if (other === item) return;
        const otherSub = other.querySelector(".header__menu-sub-menu");
        if (otherSub) otherSub.classList.remove("submenu-open");
      });

      submenu.classList.toggle("submenu-open");
    });
  });

  if (elements.searchForm && elements.searchIcon) {
    elements.searchIcon.addEventListener("click", (e) => {
      e.preventDefault();
      elements.searchForm.classList.toggle("active");
      if (elements.searchForm.classList.contains("active") && elements.searchInput) {
        setTimeout(() => elements.searchInput.focus(), 300);
      }
    });
  }

  if (elements.closeSearch && elements.searchForm) {
    elements.closeSearch.addEventListener("click", () => {
      closeSearchForm();
    });
  }
};
